import api from '../../api'
import {CONTRACTORS_CREATE, CONTRACTORS_UPDATE, CONTRACTORS_DELETE} from '../mutations/available'
import {showApiError} from '../../helpers/notification'
import store from '../index'

export const contractorCreate = async ({commit, dispatch, state}, contractor) => {
  let created = null
  try {
    created = await api.createContractor(contractor)
    commit(CONTRACTORS_CREATE, created)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to create contractor')
    console.log(`Unable to create contractor, details: ${JSON.stringify(e)}`)

    throw e
  }

  return created
}

export const contractorUpdate = async ({commit, dispatch, state}, contractor) => {
  let updated = null
  try {
    updated = await api.updateContractor(contractor)
    commit(CONTRACTORS_UPDATE, updated)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to update contractor')
    console.log(`Unable to update contractor, details: ${JSON.stringify(e)}`)

    throw e
  }

  return updated
}

export const contractorDelete = async ({commit, dispatch, state}, contractor) => {
  try {
    await api.deleteContractor(contractor)
    commit(CONTRACTORS_DELETE, contractor)
  } catch (e) {
    showApiError(store.$app, e, 'Unable to delete contractor')
    console.log(`Unable to delete contractor, details: ${JSON.stringify(e)}`)

    throw e
  }

  return true
}



// WEBPACK FOOTER //
// ./src/store/actions/contractors.js